function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from 'react-router-dom';
import App from "./App";
import AppModal from "./components/MessageModal";
var MessageCenterWorkbench = /*#__PURE__*/function () {
  function MessageCenterWorkbench() {
    _classCallCheck(this, MessageCenterWorkbench);
  }
  _createClass(MessageCenterWorkbench, [{
    key: "render",
    value: function render(_ref) {
      var userId = _ref.userId,
        Weblog = _ref.Weblog,
        _ref$system = _ref.system,
        system = _ref$system === void 0 ? 'merchant' : _ref$system;
      var app = document.getElementById('app-workbench-message-center');
      if (app && userId) {
        ReactDOM.render( /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(App, {
          userId: userId,
          Weblog: Weblog,
          system: system
        })), app);
      }
    }
  }]);
  return MessageCenterWorkbench;
}();
var MessageModal = /*#__PURE__*/function () {
  function MessageModal() {
    _classCallCheck(this, MessageModal);
  }
  _createClass(MessageModal, [{
    key: "render",
    value: function render(_ref2) {
      var _ref2$system = _ref2.system,
        system = _ref2$system === void 0 ? 'merchant' : _ref2$system,
        _ref2$url = _ref2.url,
        url = _ref2$url === void 0 ? '/league/admin/mew/home' : _ref2$url;
      var root = document.getElementById('@@@workbench-message-modal@@@');
      if (!root) {
        var divElement = document.createElement('div');
        divElement.id = '@@@workbench-message-modal@@@';
        root = document.body.appendChild(divElement);
      }
      ReactDOM.render( /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(AppModal, {
        system: system,
        url: url
      })), root);
    }
  }]);
  return MessageModal;
}();
export { MessageModal };
export default MessageCenterWorkbench;